import Handlebars from "handlebars/dist/handlebars.js";

var createbanner = (function () {
    "use strict";

    if ($('.createbanner').length > 0) {

        $('body').on('click', '#generate-banner', generateBanner);

        $('body').on('keydown', function (e) {
            if (e.keyCode === 13) {
                return false;
            }
        });

    }

    function generateBanner(e) {
        e.preventDefault();

        var $this = $(this),
			createbanner = $this.closest('.createbanner'),
			source = $('#banner-code-template').html(),
            template = Handlebars.compile(source),
            bannerType = $("#bannertype-container select"),
            bannerSize = $("#bannersize-container select"),
            bannerTypeText = $("option:selected", bannerType).text(),
            bannerSizeText = $("option:selected", bannerSize).text(),
            errorMessage = $('#generate-banner').attr('data-error-message'),
            data = getData();


        if (data.accountId === "" || data.accountId === undefined) {
            createErrorMessage("Var god välj en förening.");
            return;
        }

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.site.methods.getBannerCode,
            data: JSON.stringify(data),
            dataType: "text"
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            if (response.length > 0) {
                Utils.TrackGoogleEvent("Foreningsbanner", "Skapa", bannerTypeText + ", " + bannerSizeText);
               
                var html = template({ Code: response });

                $('.modal').append(html);
                $('.modal .banner-code textarea').select();
            } else {
                createErrorMessage(errorMessage);
            }
            
        }

        function getData() {
            if ($("#association-id").val().length > 0) {
                return {
                    "bannerSizeId": $("#bannersize-container select").val() != "" ? $("#bannersize-container select").val() : "0",
                    "accountId": $("#association-id").val(),
                    "bannerType": $("#bannertype-container select").val()
                };
            }
            else {
                return {
                    "bannerSizeId": $("#bannersize-container select").val() != "" ? $("#bannersize-container select").val() : "0",
                    "accountId": "",
                    "bannerType": $("#bannertype-container select").val()
                };
            }
        }

        function failHandler(err) {
            createErrorMessage(SETTINGS.exceptions.generic);
        }

        function createErrorMessage(errorMessage) {
            var source = $('#banner-code-error-template').html(),
			    template = Handlebars.compile(source),
                data = {
                    "Message": new Handlebars.SafeString(errorMessage)
                };

            var html = template(data);
            $('.modal').empty().append(html);
        }
    }

})();